// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-select--none {\n  user-select: none; }\n\n.user-select--initial {\n  user-select: initial; }\n\n@media screen and (max-width: 599px) {\n  .drawer-desktop {\n    display: none; } }\n", ""]);
// Exports
module.exports = exports;
